// import React, { useEffect, useRef } from "react";

// const data = [{ name: "item 1" }, { name: "item 2" }];

// export default function Timeline() {
//   const timelineRef = useRef(null);
//   const drawLineRef = useRef(null);
//   const itemsRef = useRef([]);

//   useEffect(() => {
//     const handleScroll = () => {
//       const drawLine = drawLineRef.current;
//       const timeline = timelineRef.current;
//       const items = itemsRef.current;

//       if (!drawLine || !timeline || items.length === 0) return;

//       const greyLineHeight = timeline.offsetHeight;
//       const windowDistance = window.scrollY;
//       const windowHeight = window.innerHeight / 2;
//       const timelineDistance =
//         timeline.getBoundingClientRect().top + window.scrollY;

//       if (windowDistance >= timelineDistance - windowHeight) {
//         let line = windowDistance - timelineDistance + windowHeight;

//         if (line <= greyLineHeight) {
//           drawLine.style.height = `${line + 20}px`;
//         }
//       }

//       const bottom =
//         drawLine.getBoundingClientRect().top + drawLine.offsetHeight;

//       items.forEach((item, index) => {
//         if (item) {
//           const circlePosition = item.getBoundingClientRect().top;

//           // Check if the bottom of the line is past the top of the item
//           if (bottom > circlePosition) {
//             item.classList.add("in-view");
//           } else {
//             item.classList.remove("in-view");
//           }
//         }
//       });
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <div className="timeline" ref={timelineRef}>
//       <ul>
//         <span className="default-line"></span>
//         <span className="draw-line" ref={drawLineRef}></span>
//         {data.map((item, index) => (
//           <li key={index} ref={(el) => (itemsRef.current[index] = el)}>
//             <div>{item.name}</div>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// import React, { useEffect, useRef } from "react";

// export default function LineScroll({ isVisible }) {
//   const path1Ref = useRef(null);
//   const path2Ref = useRef(null);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (!isVisible) return;

//       const path1 = path1Ref.current;
//       const path2 = path2Ref.current;

//       if (path1 && path2) {
//         const path1Length = path1.getTotalLength();
//         const path2Length = path2.getTotalLength();

//         // Set initial dash offset and color to the same color as the stroke
//         path1.style.strokeDashoffset = path1Length;
//         path2.style.strokeDashoffset = path2Length;

//         // Calculate the scroll percentage
//         const scrollPercentage =
//           window.scrollY / (document.body.scrollHeight - window.innerHeight);

//         // Change the stroke color based on the scroll percentage
//         const newStrokeColor = scrollPercentage > 0.1 ? "#F26739" : "#333"; // Change #333 to the color you want after scroll

//         path1.style.strokeDashoffset =
//           path1Length - scrollPercentage * path1Length;
//         path2.style.strokeDashoffset =
//           path2Length - scrollPercentage * path2Length;

//         path1.style.stroke = newStrokeColor;
//         path2.style.stroke = newStrokeColor;
//       }
//     };

//     if (isVisible) {
//       window.addEventListener("scroll", handleScroll);
//     }

//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [isVisible]);

//   return (
//     <svg
//       width="120"
//       height="1312"
//       viewBox="0 0 120 1312"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         ref={path1Ref}
//         d="M40.3123 0C40.3123 217.015 57.2221 797.801 1 1311"
//         stroke="#F26739"
//         strokeDasharray="10 5"
//       />
//       <path
//         ref={path2Ref}
//         d="M79.6877 0C79.6877 217.015 62.7779 797.801 119 1311"
//         stroke="#F26739"
//         strokeDasharray="10 5"
//       />
//     </svg>
//   );
// }

import React from "react";

export default function LineScroll() {
  return (
    <>
      <svg
        className="mobileshow"
        width="75"
        height="1766"
        viewBox="0 0 75 1766"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.339 170.476C25.0356 103.19 24.776 45.6281 24.776 0H25.4063C25.4063 45.6133 25.6658 103.162 25.9693 170.438C27.6103 534.261 30.5345 1182.55 0.626174 1766L0 1765.84C29.9032 1182.49 26.9799 534.313 25.339 170.476Z"
          fill="#F26739"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.661 170.476C49.9644 103.19 50.224 45.6281 50.224 0H49.5937C49.5937 45.6133 49.3342 103.162 49.0307 170.438C47.3897 534.261 44.4655 1182.55 74.3738 1766L75 1765.84C45.0968 1182.49 48.0201 534.313 49.661 170.476Z"
          fill="#F26739"
        />
      </svg>

      <svg
        className="desktopshow"
        width="120"
        height="1312"
        viewBox="0 0 120 1312"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M40.3123 0C40.3123 217.015 57.2221 797.801 1 1311"
          stroke="#F26739"
        />
        <path
          d="M79.6877 0C79.6877 217.015 62.7779 797.801 119 1311"
          stroke="#F26739"
        />
      </svg>
    </>
  );
}
